export default function phoneFormat(val) {
    if (val) {
        return val.replace(/^(\d)(\d{3})(\d+)/g, '$1 ($2) $3');
    }
    return val;
}
